import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from "./handlers";

declare const window: any;

export const recaptchaApi = createApi({
    reducerPath: 'recaptcha',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.RECAPTCHA_URL ?? 'https://npr-recaptcha.api.pens.com/v1/verify',
        prepareHeaders: (headers) => {
            headers.set('x-api-key', window.Config.NP_API_KEY_CLIENT_JS);
            return headers
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        validateCaptcha: builder.query({
            async queryFn(cartId, {dispatch}, _extraOptions,  baseQuery) 
            {
                const reCapToken = await window.grecaptcha.execute(window.Config.RECAPTCHA_SITE_KEY, { action: 'submit' });
                const reCapData = {
                    token: reCapToken,
                    action: 'Checkout Payment',
                    requestOrigin: 'Website',
                    type: 'cart',
                    id: cartId
                };
                const data : any = await baseQuery({ url: window.Config.RECAPTCHA_URL, method: 'POST', body: reCapData});
                return data;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data
                }
                catch (error) {
                    console.log(error);
                    dispatch(onErrorHandler({ operation: "validateRecaptcha", err: JSON.stringify(error), errMsg: 'Error: while validating recaptcha', api: 'recaptcha/api', mainItemId: args.mainItemId }));
                }
            }
        }),
        validatePreferenceCaptcha: builder.query({
            async queryFn(ueseId, {dispatch}, _extraOptions,  baseQuery) 
            {
                const reCapToken = await window.grecaptcha.execute(window.Config.RECAPTCHA_SITE_KEY, { action: 'submit' });
                const reCapData = {
                    token: reCapToken,
                    action: 'Customer Preference',
                    requestOrigin: 'Website',
                    type: 'user',
                    id: ueseId
                };
                const data : any = await baseQuery({ url: window.Config.RECAPTCHA_URL, method: 'POST', body: reCapData});
                return data;
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data
                }
                catch (error) {
                    console.log(error);
                    dispatch(onErrorHandler({ operation: "validatePreferenceCaptcha", err: JSON.stringify(error), errMsg: 'Error: while validating recaptcha', api: 'recaptcha/api', mainItemId: args.mainItemId }));
                }
            }
        })
    }),
})

export const { useValidateCaptchaQuery, useValidatePreferenceCaptchaQuery } = recaptchaApi;